// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__3aNlg","secondOption":"Toggle_secondOption__2aFxC","firstOption":"Toggle_firstOption__N4oWj"};